export default (node) => {
  const messageNode = node.querySelector('[data-cart-toast-message]');
  const textNode = node.querySelector('[data-cart-toast-text]') || messageNode;
  const closeBtn = node.querySelector('[data-cart-toast-close]');
  let hideTimeout = null;
  let showTimeout = null;

  const HIDE_DELAY = 5000;

  const clearHide = () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }
  };

  const hide = () => {
    clearHide();
    if (showTimeout) {
      clearTimeout(showTimeout);
      showTimeout = null;
    }
    node.classList.remove('cart-toast-visible');
  };

  const scheduleHide = () => {
    clearHide();
    hideTimeout = setTimeout(hide, HIDE_DELAY);
  };

  const show = (message) => {
    if (showTimeout) clearTimeout(showTimeout);
    clearHide();
    // Clear first so an identical, repeated error is still re-announced (WCAG 4.1.3)
    textNode.textContent = '';

    // Position toast at the top of the cart items area. Clear first: the drawer
    // is absent on /cart, so a stale offset would otherwise survive the lookup.
    node.style.top = '';
    const cartDrawer = document.querySelector('[data-cart-drawer-content]');
    if (cartDrawer) {
      const itemsContainer = cartDrawer.querySelector('.overflow-y-scroll');
      if (itemsContainer) {
        const rect = itemsContainer.getBoundingClientRect();
        node.style.top = rect.top + 'px';
      }
    }

    // Wait for cart drawer slide-in transition (800ms) before showing.
    // Reveal before writing the text: the hidden toast is visibility:hidden and so
    // outside the a11y tree, where a live-region update would go unannounced.
    showTimeout = setTimeout(() => {
      node.classList.add('cart-toast-visible');
      requestAnimationFrame(() => {
        textNode.textContent = message;
      });
      scheduleHide();
    }, 800);
  };

  // Pause auto-dismiss while hovered or focused, resume on leave/blur (WCAG 2.2.1)
  const resumeIfVisible = () => {
    if (node.classList.contains('cart-toast-visible')) scheduleHide();
  };
  node.addEventListener('mouseenter', clearHide);
  node.addEventListener('mouseleave', resumeIfVisible);
  node.addEventListener('focusin', clearHide);
  node.addEventListener('focusout', resumeIfVisible);

  if (closeBtn) closeBtn.addEventListener('click', hide);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && node.classList.contains('cart-toast-visible')) hide();
  });

  document.addEventListener('cart:error', (e) => {
    if (e.detail) show(e.detail);
  });
};
